
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#fff","d":"M3.091 4.656h11.484v9.613H3.091z"}}),_c('path',{attrs:{"d":"M8.54.821L.202 3.334v8.56c0 5.599 8.338 7.927 8.338 7.927s8.338-2.328 8.338-7.931V3.33L8.54.82zM6.845 13.893l-3.116-3.116 1.134-1.134 1.986 1.986 5.372-5.376 1.134 1.134-6.51 6.506z","fill":"#016AAE"}})])
          )
        }
      }
    